// Lógica para forzar ?pais=cl en el dominio de Chile al cargar la página.
  const targetDomain = 'keep.cl';
  const forcedCountryParam = 'cl';
  const currentUrlParams = new URLSearchParams(window.location.search);

  if (window.location.hostname === targetDomain && !currentUrlParams.has('pais')) {
    currentUrlParams.append('pais', forcedCountryParam);
    const newUrl = `${window.location.pathname}?${currentUrlParams.toString()}${window.location.hash}`;
    history.replaceState({ path: newUrl }, '', newUrl);
  }

  // Variables para el selector
  const selected = document.getElementById('selected-option');
  const options = document.getElementById('country-options');
  const countryItems = options.querySelectorAll('li');

  // Mostrar/ocultar opciones
  selected.addEventListener('click', (event) => {
    event.stopPropagation();
    options.style.display = options.style.display === 'block' ? 'none' : 'block';
  });

  // Función para mostrar sección según país
  function applyCountryContent(country) {
    document.querySelectorAll('[data-country]').forEach(el => {
      el.style.display = 'none';
    });

    const countrySections = document.querySelectorAll('[data-country="' + country + '"]');
    
    if (countrySections.length > 0) {
      countrySections.forEach(el => {
        el.style.display = ''; 
      });
    } else {
      document.querySelectorAll('[data-country="general"]').forEach(el => {
        el.style.display = '';
      });
    }

    const newSearch = (country && country !== 'general') ? '?pais=' + country : '';
    const newUrl = window.location.pathname + newSearch;
    if (window.location.search !== newSearch) {
      history.pushState({}, '', newUrl);
    }
  }

  // Al hacer clic en una opción
  countryItems.forEach(item => {
    item.addEventListener('click', () => {
      const selectedCountry = item.dataset.value;
      const img = item.querySelector('img');
      
      selected.innerHTML = `<img src="${img.src}" alt="${img.alt}" title="${img.alt}">`;
      localStorage.setItem('selectedCountry', selectedCountry);
      applyCountryContent(selectedCountry);

      // --- AJUSTE 1: LÓGICA DE REDIRECCIÓN ---
      if (selectedCountry === 'cl') {
        window.location.href = `https://keep.cl/?pais=${selectedCountry}`;
      } else if (selectedCountry === 'uy') {
        window.location.href = `https://keep.uy/?pais=${selectedCountry}`;
      } else if (selectedCountry === 'pe') { // Se añade la nueva regla para Perú
        window.location.href = `https://keep.com.pe/?pais=${selectedCountry}`;
      } else if (selectedCountry === 'general') { // Se quita 'pe' de este grupo
        const destinationUrl = 'https://be-keep.com';
        window.location.href = destinationUrl;
      } else if (selectedCountry === 'ar') {
        window.open('https://www.clubdeobsequios.com.ar/shop/category/keep-9', '_blank');
        if (window.location.hostname !== 'be-keep.com') {
          window.location.href = `https://be-keep.com/?pais=${selectedCountry}`;
        }
      } else if (selectedCountry === 'co') {
        window.open('https://www.estra.com/keep', '_blank');
        if (window.location.hostname !== 'be-keep.com') {
            window.location.href = `https://be-keep.com/?pais=${selectedCountry}`;
        }
      }
      
      options.style.display = 'none';
    });
  });

  // Lógica de inicialización al cargar la página
  const finalUrlParams = new URLSearchParams(window.location.search);
  let initialCountry;

  // 1. La prioridad más alta es el parámetro 'pais' en la URL.
  if (finalUrlParams.has('pais')) {
    initialCountry = finalUrlParams.get('pais');
  } else {
    // 2. Si no hay parámetro, decidimos el país por defecto según el DOMINIO actual.
    // --- AJUSTE 2: LÓGICA DE DOMINIO ---
    if (window.location.hostname === 'keep.cl') {
      initialCountry = 'cl';
    } else if (window.location.hostname === 'keep.uy') {
      initialCountry = 'uy';
    } else if (window.location.hostname === 'keep.com.pe') { // Se añade la nueva regla para Perú
      initialCountry = 'pe';
    } else if (window.location.hostname === 'be-keep.com') {
      initialCountry = 'general';
    } else {
      // 3. Como último recurso (para otros dominios o pruebas locales), usamos localStorage.
      initialCountry = localStorage.getItem('selectedCountry') || 'general';
    }
    
    // Ahora, actualizamos la URL visible en la barra de direcciones para que refleje este estado,
    // SIN recargar la página.
    const newSearch = (initialCountry && initialCountry !== 'general') ? `?pais=${initialCountry}` : '';
    if (newSearch !== window.location.search.split('&')[0].split('?')[1] ? '?' + window.location.search.split('&')[0].split('?')[1] : '') {
        const newUrl = window.location.pathname + newSearch + window.location.hash;
        history.replaceState({ path: newUrl }, '', newUrl);
    }
  }

  // 4. Finalmente, aplicamos el contenido y actualizamos el ícono del selector
  const initialOption = options.querySelector(`[data-value="${initialCountry}"]`);
  if (initialOption) {
    const img = initialOption.querySelector('img');
    selected.innerHTML = `<img src="${img.src}" alt="${img.alt}" title="${img.alt}">`;
  }
  applyCountryContent(initialCountry);


  // Listener para los botones de atrás/adelante del navegador
  window.addEventListener('popstate', function () {
    const popParams = new URLSearchParams(window.location.search);
    const country = popParams.get('pais') || 'general';
    applyCountryContent(country);

    const option = options.querySelector(`[data-value="${country}"]`);
    if (option) {
      const img = option.querySelector('img');
      selected.innerHTML = `<img src="${img.src}" alt="${img.alt}" title="${img.alt}">`;
    }
  });

  // Cierra el menú si se hace clic fuera
  document.addEventListener('click', () => {
    options.style.display = 'none';
  });

  // Lógica para controlar los carruseles
  document.querySelectorAll('.seccion-destacados').forEach(section => {
    const contenedor = section.querySelector('.contenedor-destacados');
    const flechaIzq = section.querySelector('.flecha-desplazamiento.izquierda');
    const flechaDer = section.querySelector('.flecha-desplazamiento.derecha');

    if (contenedor && flechaIzq && flechaDer) {
      const scrollAmount = 300;
      flechaIzq.addEventListener('click', () => {
        contenedor.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
      flechaDer.addEventListener('click', () => {
        contenedor.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }
  });